import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { route } from '../navigation/routes';
import i18n from '../common/i18n';
import moto from '../../assests/images/home/moto.png';
import telephone from '../../assests/images/home/telephone.png';
import monitor from '../../assests/images/home/monitor.png';
import money from '../../assests/images/home/money.png';

const HomeWhatForSection = () => {
  const isMobile = useMediaQuery('(max-width: 1024px)');

  return (
    <Box
      sx={{
        backgroundColor: '#F5F5F5',
        border: '1px solid #CCCCCC !important',
        borderRadius: '12px !important',
        padding: isMobile ? '32px 16px' : '32px',
        width: isMobile ? '90%' : '85%',
        margin: 'auto',
        marginTop: '16px',
        marginBottom: '16px',
      }}
    >
      <Box>
        <Typography variant="h3" fontWeight={800} className="lettersMagentaNew" mb={2}>
          {i18n.homeForWhat}
        </Typography>
      </Box>
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <Grid item xs={5.5} md={2.8} className="boxForWhatN" backgroundColor="#E4056F">
          <a
            href={route.motorcycle}
            style={{ textDecoration: 'none', color: 'inherit' }}
            className="flexCenterForWhat"
          >
            <img src={moto} alt="moto" height="85px" />
            <Typography variant="h6" className="lettersWhiteOnly">
              {i18n.homeBuyMoto}
            </Typography>
          </a>
        </Grid>

        <Grid item xs={5.5} md={2.8} className="boxForWhatN" backgroundColor="#E4056F">
          <span
            style={{ textDecoration: 'none', color: 'inherit' }}
            className="flexCenterForWhat"
          >
            <img src={telephone} alt="telephone" height="110px" />
            <Typography variant="h6" className="lettersWhiteOnly">{i18n.homeCellphone}</Typography>
          </span>
        </Grid>

        <Grid item xs={5.5} md={2.8} className="boxForWhatN" backgroundColor="#E4056F">
          <a
            href={route.electro}
            style={{ textDecoration: 'none', color: 'inherit' }}
            className="flexCenterForWhat"
          >
            <img src={monitor} alt="monitor" height="85px" />
            <Typography variant="h6" className="lettersWhiteOnly">{i18n.homeBuyElectro}</Typography>
          </a>
        </Grid>

        <Grid item xs={5.5} md={2.8} className="boxForWhatN" backgroundColor="#E4056F">
          <span
            style={{ textDecoration: 'none', color: 'inherit' }}
            className="flexCenterForWhat"
          >
            <img src={money} alt="money" height="75px" />
            <Typography variant="h6" className="lettersWhiteOnly">{i18n.homePayService}</Typography>
          </span>
        </Grid>

      </Grid>
    </Box>
  );
};

export default HomeWhatForSection;
